import { nanoid } from "nanoid";
import { safeLocalStorage } from "./safeLocalStorage";

export function getEmailFingerprint(email: string) {
  const storageKey = `fingerprint-${email}`;
  try {
    const storedValue = safeLocalStorage.getItem(storageKey);
    if (storedValue) return JSON.parse(storedValue);

    const id = nanoid();
    safeLocalStorage.setItem(storageKey, JSON.stringify(id));
    return id;
  } catch (error) {
    const id = nanoid();
    safeLocalStorage.setItem(storageKey, JSON.stringify(id));
    return id;
  }
}
